module.exports = __webpack_public_path__ + "img/burger.d14edae1.svg";